import type {
  UserGetPortfolioChartInput,
  UserGetWalletPortfolioChartInput,
} from '../api'
import { useQuery } from '@tanstack/react-query'
import {
  portfolioOptions,
  userPerformanceOptions,
  userPortfolioChartOptions,
  walletPortfolioChartOptions,
} from './user-portfolio.options'
export const useUserPortfolio = () => {
  return useQuery(portfolioOptions())
}

export const useUserPortfolioChart = (params: UserGetPortfolioChartInput) => {
  return useQuery(userPortfolioChartOptions(params))
}
export const useWalletPortfolioChart = (
  params: UserGetWalletPortfolioChartInput,
) => {
  return useQuery(walletPortfolioChartOptions(params))
}

export const useUserPerformance = () => {
  return useQuery(userPerformanceOptions())
}
